import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import { ALL_LANGUAGES } from '../../constants'
import getSymbolFromCurrency from 'currency-symbol-map'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.css'

class ActivitySummary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailsShown: true,
      photos: [{}, {}, {}]
    }
  }

  componentWillMount() {
    let photos = []

    if (this.props.summary.photos) {
      this.props.summary.photos.forEach((photo, index) => {
        photos.push(photo)
      })
      for (let i = 0; i < 3 - this.props.summary.photos.length; i++) {
        photos.push({})
      }

      this.setState({
        photos: photos
      })
    }
  }

  componentDidMount() {
    this.setState({
      detailsShown: true
    })

    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        this.setState({
          detailsShown: true
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    let photos = []

    if (nextProps.summary.photos) {
      nextProps.summary.photos.forEach((photo, index) => {
        photos.push(photo)
      })
      for (let i = 0; i < 3 - nextProps.summary.photos.length; i++) {
        photos.push({})
      }

      this.setState({
        photos: photos
      })
    } else {
      this.setState({
        photos: [{}, {}, {}]
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => {})
  }

  viewDetails() {
    this.setState({
      detailsShown: !this.state.detailsShown
    })
  }

  searchLanguaegs = langId => {
    return ALL_LANGUAGES.filter(lang => {
      if (lang['1'] === langId) {
        return lang.name
      } else {
        return null
      }
    })
  }

  renderLanguages = languages => {
    if (!languages) return ''
    let string
    if (languages.length > 1) {
      const langArray = languages.length > 0 ? languages.map(langId => this.searchLanguaegs(langId)[0].name) : []
      string = langArray.slice(0, -1).join(', ') + ' and  ' + langArray[langArray.length - 1]
    } else {
      string = ALL_LANGUAGES[languages[0]]
    }
    return string
  }

  checkPhotos = photos => photos.filter(photo => !!photo.src)

  render() {
    const { summary, t } = this.props
    let currency
    summary.currency ? (currency = getSymbolFromCurrency(summary.currency)) : (currency = '')

    return (
      <div className={summary.title ? 'activity-summary ' + this.props.extraClass : 'hidden'}>
        <div className={this.state.detailsShown ? 'review' : 'hidden'}>
          {!!this.checkPhotos(this.state.photos).length && (
            <div className="finishPage__carousel">
              <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
                {this.state.photos.filter(photo => photo.src).map((photo, index) => (
                  <div className="carouselPhoto" key={index}>
                    <img style={{ minHeight: 192, maxHeight: 192 }} src={photo.src} alt="" />
                  </div>
                ))}
              </Carousel>
            </div>
          )}

          <h2 className="section title">{summary.title}</h2>

          <div className={summary.shortDescription ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.shortDescription}</span>
            </div>
          </div>

          <div className={summary.tourLocation ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">Location</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.tourLocation && summary.tourLocation.description}</span>
            </div>
          </div>

          <div className={summary.languages ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('languages')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.languages ? this.renderLanguages(summary.languages) : ''}</span>
            </div>
          </div>
          <div className={summary.categories ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('categories')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
                {summary.categories ? summary.categories.map((category, index) => <div key={index}>{category}</div>) : ''}
              </span>
            </div>
          </div>

          <div className={summary.tags ? 'row summary__item tags_row' : 'hidden'}>
            <span className="activity-summary__tags">
              {summary.tags
                ? summary.tags.map((tag, index) => (
                    <div className="activity-summary__tags__tag" key={index}>
                      {tag.value}
                    </div>
                  ))
                : ''}
            </span>
          </div>

          <div className={summary.whatWeDo ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__title">{t('what_we_do')}</span>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.whatWeDo}</span>
            </div>
          </div>

          <div className={summary.whereWeBe ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__title">{t('where_will_be')}</span>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.whereWeBe}</span>
            </div>
          </div>

          <div className={summary.whatWeProvide ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__title">{t('what_i_provide')}</span>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.whatWeProvide}</span>
            </div>
          </div>

          <div className={summary.whatYouBring ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__title">{t('what_bring')}</span>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.whatYouBring}</span>
            </div>
          </div>

          <div className={summary.securityNotice ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__title">{t('security_notice')}</span>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.securityNotice}</span>
            </div>
          </div>

          <div className={summary.weatherNotice ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__title">{t('weather_notice')}</span>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span className="summary__item__value">{summary.weatherNotice}</span>
            </div>
          </div>

          <div className={summary.meetingPoint ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('meeting_point')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.meetingPoint ? summary.meetingPoint.description : ''}</span>
            </div>
          </div>

          <div className={summary.groupRange ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('group_size')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.minGroupSize + ' - ' + summary.maxGroupSize}</span>
            </div>
          </div>

          <div className={summary.estimatedDurationHours ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('duration')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.estimatedDurationHours}</span>
            </div>
          </div>

          <div className={summary.privateTourPrice ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('private_tour_price')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.privateTourPrice + currency}</span>
            </div>
          </div>

          <div className={summary.groupPrice ? 'row summary__item' : 'hidden'}>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('group_price')}</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">{summary.groupPrice + currency}</span>
            </div>
          </div>
        </div>

        <div className="total-wrapper row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div className="show-mobile result-mobile">
              <button className="view-details" onClick={() => this.viewDetails()}>
                {t('view_details')}
              </button>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12" />
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('activity_steps'))

export default enhance(ActivitySummary)



// WEBPACK FOOTER //
// src/components/ActivitySteps/ActivitySummary.jsx